/**
 * @class
 */
export default class CantShipTogetherError extends Error {
    constructor() {
        super("Sorry, we can't process this order altogether due to item's unavailability in warehouses. Please split this order to individual items and try again");
        this.name = "CantShipTogetherError";
    }
}